define('viewmodels/pages/cash/methods/neteller/UseNetellerDepositViewModel',['underscore', 'knockout'], function(_, ko) {

    function UseNetellerDepositViewModel(DepositAmountStep, formFields, depositPage, depositModel, Wizard) {

        var methodModel = depositModel.methodModel();

        this.wizardModel = new Wizard({
            steps: [
                new DepositAmountStep(depositModel),
                {
                    field: formFields.numberField( methodModel.secureId ),
                    label: depositPage.findFieldByName('neteller_secure_id_label'),
                    smallInfo: null,
                    type: 'basicfield'
                }
            ]
        });
    }

    UseNetellerDepositViewModel.prototype.getView = function() {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return UseNetellerDepositViewModel;

});

